// extracted by mini-css-extract-plugin
module.exports = {"container":"Resize_container__2qkyx","child":"Resize_child__1bNxU"};